import { makeStyles } from '@material-ui/core';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  buttonGroup: {
    paddingTop: '14.5px',
  },
  button: {
    borderStyle: 'none',
    color: 'black',
    fontWeight: 'bold',
    margin: '0',
    padding: '5px',
    textTransform: 'none',
    '&.MuiToggleButton-root.Mui-selected': {
      color: 'rgb(255 255 255 / 82%)',
      backgroundColor: '#26a69a',
    },
  },
}));

const AlphabetPicker = ({ onClickHandler, letterValue }) => {
  const classes = useStyles();
  const alphabetList = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '#'];

  const clickHandler = (e) => {
    onClickHandler(e.currentTarget.value);
  };

  return (
    <ToggleButtonGroup className={classes.buttonGroup} orientation="vertical" aria-label="alphabet picker" value={letterValue} exclusive>
      {alphabetList.map((letter) => (
        <ToggleButton className={classes.button} key={letter} onClick={clickHandler} value={letter === '#' ? letter : letter.toLowerCase()}>
          {letter}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default AlphabetPicker;
